<template>
  <div>
    <div class="titlePage">Limpo</div>
    <form @submit.prevent="criarMetaDados" autocomplete="off">
      <b-row class="mt-4">
        <b-col sm="6">
          <fcc-select
            class="mb-4"
            placeholder="Selecione um campo"
            labelField="camponovo"
            valueField="id"
            v-model="campoFicha"
            :options="lstCamposFilter"
            required
          >
            Campo ficha
          </fcc-select>
        </b-col>
        <b-col sm="5">
          <fcc-select
            class="mb-4"
            placeholder="Selecione um campo"
            labelField="descricao"
            valueField="idcampo"
            v-model="campoMetaDados"
            :options="lstCampoMeta"
            required
          >
            Campo meta dados
          </fcc-select>
        </b-col>
        <b-col sm="1">
          <button
            v-b-tooltip.hover
            title="Adicionar"
            type="submit"
            class="btn btn-light border shadow-sm ml-2 text-dark"
          >
            <font-awesome-icon icon="plus" size="lg" />
          </button>
        </b-col>
      </b-row>
    </form>
    <div class="row mt-3">
      <div class="col-sm-12">
        <fccTable
          striped
          hover
          :fields="fieldsCampoMetaDados"
          :orderby="sortBy"
          :items="lstCampoMetaDados"
          responsive
          :optionsButton="optionsCampoMetaDados"
          :porPage="itemPorPage"
          :titlePage="titlePage"
          :actions="actionsCampoMetaDados"
          :mostrarQuantidade="false"
          :titlePDF="titlePage"
        ></fccTable>
      </div>
      <div class="col-sm-12">
        <fcc-button
          @click="gerarLimpo()"
          :disabled="
            !store.state.permissaoMenu.adicionar || lstCampoMetaDados.length == 0 || !verificaData()
          "
        >
          Gerar Limpo
        </fcc-button>
        <fcc-button
          @click="gerarInclusao()"
          class="ml-2"
          :disabled="
            !store.state.permissaoMenu.adicionar || lstCampoMetaDados.length == 0 || !verificaData()
          "
        >
          Gerar Inclusão
        </fcc-button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../store'
export default {
  data() {
    return {
      titlePage: 'Campos metadados',
      sortBy: 'nome',
      itemPorPage: '1000',
      lstCampoMeta: [],
      campoFicha: '',
      campoMetaDados: '',
      lstControle: [],
      lstCamposFilter: [],
      optionsCampoMetaDados: [],
      store,
      lstCampoMetaDados: [],
      actionsCampoMetaDados: [
        {
          button: true,
          funcaoButton: 'deleteMetaDados',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      fieldsCampoMetaDados: [
        { key: 'nmcampoficha', label: 'Campo ficha', sortable: true },
        { key: 'idcampometadado', label: 'ID Campo', sortable: true },

        { key: 'nmcampometa', label: 'Campo meta', sortable: true },
        { key: 'actions', label: '' }
      ],
      listagemDataPublicacao: []
    }
  },
  props: {
    metaDados: Object,
    idPublicacao: Number
  },
  methods: {
    listandoDatas() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listandoDatasGenerico(this.idPublicacao)
        .then((response) => {
          this.listagemDataPublicacao = response.data
        })
        .catch(this.setErrorSystem)
        .finally(() => {
          this.verificaData()
          this.carregaTexto()
        })
    },
    verificaData() {
      if (this.listagemDataPublicacao.length > 0) {
        let moments = ''
        let dataFim = ''
        if (this.listagemDataPublicacao.length > 1) {
          moments = this.listagemDataPublicacao.map((d) =>
            this.$moment(d.dtfim, 'DD-MM-YYYY HH:mm:ss')
          )
          dataFim = this.$moment(this.$moment.max(moments), 'MM-DD-YYYY').format(
            'YYYY-MM-DD HH:mm:ss'
          )
        } else {
          moments = this.$moment(this.listagemDataPublicacao[0].dtfim, 'DD-MM-YYYY HH:mm:ss')
          dataFim = this.$moment(moments, 'MM-DD-YYYY').format('YYYY-MM-DD HH:mm:ss')
        }
        const agora = this.$moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
        return this.$moment(agora).isAfter(dataFim)
      }
      return false
    },
    gerarLimpo() {
      this.callConfirm(`Tem certeza que deseja gerar a limpo?`, '').then(() => {
        const payload = {
          spi: this.metaDados.spi
        }
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            store.state.baseUrlPublicacao + 'PublicacaoCorrecaoCadastral/CriaLimpoDadosCadastrais',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast('Sucesso ao Gerar Limpo')
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
          .finally(this.carregaTexto)
      })
    },
    gerarInclusao() {
      this.callConfirm(`Tem certeza que deseja gerar a inclusão?`, '').then(() => {
        const payload = {
          spi: this.metaDados.spi,
          usuario: this.dadosUserSession.usuID
        }
        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .post(
            store.state.baseUrlPublicacao + 'PublicacaoCorrecaoCadastral/GerarInclusaoLimpo',
            payload,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.callToast('Sucesso ao Gerar Inclusão')
          })
          .catch((error) => {
            this.setErrorSystem(error)
          })
          .finally(this.carregaTexto)
      })
    },
    limpaDados() {
      this.lstCamposFilter = [...this.lstCampos]
      this.lstCampoMetaDados.forEach((tabela) => {
        this.lstCamposFilter = this.lstCamposFilter.filter(
          (element) => element.id != tabela.idcampoficha
        )
        this.lstCampoMeta = this.lstCampoMeta.filter(
          (elemento) => elemento.idcampo != tabela.idcampometadado
        )
      })
    },
    deleteMetaDados(_, item) {
      this.callConfirm(this.mensagemExcluir + '?', item.nmcampometa).then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          axios
            .delete(
              store.state.baseUrlPublicacao + 'PublicacaoMetadadoCampo/Excluir/' + item.id,
              this.dadosLoginSession.fccTokenHeaders
            )
            .then(() => {
              this.listarCorrecaoCadastral()
              this.carregaTexto()
            })
        }
      })
    },
    criarMetaDados() {
      const meta = {
        id: 0,
        idCampoFicha: this.campoFicha,
        idCampoMetadado: this.campoMetaDados,
        idFormulario: this.metaDados.idformulario,
        spi: this.metaDados.spi
      }
      axios
        .post(
          store.state.baseUrlPublicacao + 'PublicacaoMetadadoCampo/Inserir',
          [meta],
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.campoFicha = ''
          this.campoMetaDados = ''
          this.listarCorrecaoCadastral()
        })
    },
    listarCamposMeta() {
      axios
        .get(
          store.state.baseUrlPublicacao + 'Publicacao/Metadados/' + this.metaDados.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCampoMeta = response.data
        })
    },
    listandoDeparaSpi: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlGestaoForm +
            'TabelaDeParaPublicacao/ListarCamposNovos/' +
            this.metaDados.idpublicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCampos = [...response.data]
          this.listarCorrecaoCadastral()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listarCorrecaoCadastral() {
      this.listarCamposMeta()
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlPublicacao + 'PublicacaoMetadadoCampo/Listar/' + this.metaDados.spi,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.lstCampoMetaDados = response.data
          this.limpaDados()
          this.carregaTexto()
        })
    }
  },
  mounted() {
    this.listandoDeparaSpi()
    this.listandoDatas()
  }
}
</script>
